import React from 'react';
import { Row, Col } from 'reactstrap';
import { USER, GUEST, TEACHER } from '../../../../Data/Constants';
import { v4 as uuid } from 'uuid';

import './Participants.css';

function Participants(props) {
    const { participants } = props;

    const guests = participants.filter(p => p.type === USER || p.type === GUEST)
        .map(p => (<li key={uuid()}>{p.name}</li>));

    const teachers = participants.filter(p => p.type === TEACHER)
        .map(p => (<li key={uuid()}>{p.name}</li>));

    return (
        <>
            <Row>
                <Col>
                    <h3>Eddigi jelentkezők</h3>
                    {guests.length > 0 &&
                        <ul className="participants">
                            {guests}
                        </ul>
                    }
                    {guests.length === 0 &&
                        <p><em>Még nem jelentkezett senki.</em></p>
                    }
                </Col>
            </Row>
            {teachers.length > 0 &&
                <Row>
                    <Col>
                        <h3>További vendégeink</h3>
                        <ul className="participants">
                            {teachers}
                        </ul>
                    </Col>
                </Row>
            }
        </>
    );
}

export default Participants;